import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class ActionResultTypesService {

  static getAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}actionresulttypes`).then((data) => {
        resolve({ actionResultTypes: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default ActionResultTypesService;
